module.exports = __webpack_public_path__ + "static/media/layout_text.0af771a1.jpg";